/* The theme's own form fields float their label: it rests in the middle of the
   box and lifts to the top when the field is focused or has something in it.
   The theme drives that in pure CSS, keyed on :placeholder-shown, which only
   matches an input that carries a placeholder attribute.

   The tracking app renders its inputs without one, so the CSS had nothing to
   key on. This adds an empty placeholder, a single space, to those inputs and
   nothing else. The app re-renders its form when someone switches tab or
   submits, so the observer puts the attribute back each time.

   Loaded by layout/theme.liquid on app proxy paths only. */
(function () {
  var SELECTOR =
    '.pp_tracking_content .pp_tracking_input input, .pp_tracking_content input.PP-TextField__Input';
  var queued = false;

  function mark() {
    queued = false;
    var inputs = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('placeholder') !== ' ') {
        inputs[i].setAttribute('placeholder', ' ');
      }
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(mark);
  }

  schedule();
  document.addEventListener('DOMContentLoaded', schedule);

  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();
